import { useRef } from 'react'

import { useBlocker } from '@tanstack/react-router'
import { LEAVE_CONFIRMATION_MESSAGE } from 'commons/constants/common'

export const useLeaveConfirmation = (preventLeaving: boolean) => {
  const ref = useRef<boolean | null>(null)

  useBlocker({
    shouldBlockFn: () => {
      if (ref.current || !preventLeaving) return false

      const shouldLeave = confirm(LEAVE_CONFIRMATION_MESSAGE)

      return !shouldLeave
    },
    enableBeforeUnload: preventLeaving
  })

  const showLeaveConfirmation = () => {
    if (preventLeaving) {
      if (confirm(LEAVE_CONFIRMATION_MESSAGE)) {
        ref.current = true
        return true
      }
      return false
    }
    return true
  }

  return {
    showLeaveConfirmation
  }
}
